<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="800"
  >
    <v-card>
      <v-card-title
        class="error white--text"
      >
        否決通知
      </v-card-title>
      <v-divider />
      <v-card-text>
        <br />
        <v-row>
          <v-col cols="12">
            <validation-observer ref="observer">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="否決理由"
                rules="required"
              >
                <v-textarea
                  v-model="forms.rejectionReason"
                  :error-messages="errors"
                  hide-details="auto"
                  rows="2"
                  label="否決理由（依頼元へ表示されます）"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>否決理由（依頼元へ表示されます）</span>
                    <span class="ml-1">
                      ({{ forms.rejectionReason?.length || 0 }} / 128)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </validation-observer>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          class="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'RejectionReasonDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      forms: {
        rejectionReason: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog () {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
    },
  },
  created() {
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent () {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          let cloned = _.cloneDeep(this.forms)
          this.$emit('registerCallback', cloned)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
